export const robots = [
  {
    id: 1,
    name: 'Jesper',
    username: 'Jakanboy177',
    email: 'jakanboy177@april.tv'
  },
  {
    id: 2,
    name: 'Adelinn',
    username: 'Addepadde',
    email: 'addepadde@april.tv'
  },
  {
    id: 3,
    name: 'Elena',
    username: 'elenamittbena',
    email: 'elenamittbena@april.tv'
  },
  {
    id: 4,
    name: 'Malin',
    username: 'MalinTheInstagramer',
    email: 'malintheinstagramer@april.tv'
  },
  {
    id: 5,
    name: 'Matilda',
    username: 'MartiniGirl',
    email: 'martinigirl@april.tv'
  },
  {
    id: 6,
    name: 'Emilia',
    username: 'WeddingGirl',
    email: 'weddinggirl@april.tv'
  },
  {
    id: 7,
    name: 'Erika',
    username: 'businessGirl',
    email: 'businessGirl@april.tv'
  },
  {
    id: 8,
    name: 'Anna',
    username: 'AnnaTheTeacher',
    email: 'annatheteacher@april.tv'
  },
  {
    id: 9,
    name: 'Emma',
    username: 'CloudyEmma',
    email: 'cloudyemma@april.tv'
  },
  {
    id: 10,
    name: 'Christoffer',
    username: 'ChisTheHacker',
    email: 'christhehacker@april.tv'
  }
]
